import { EventEmitter } from '@angular/core';
import { DateRange } from '../../../../models/date-range';
import { MeasureReportTimeline } from '../measure-setting/measure-setting.component';
import { NgbDate } from '@ng-bootstrap/ng-bootstrap/datepicker/ngb-date';
import { AchooDatepickerRangeComponent } from '../../../core/achoo-datepicker-range/achoo-datepicker-range.component';
import { NgbCalendar } from '@ng-bootstrap/ng-bootstrap';
import { NgbDateUtils } from '../../../utils/ngb-date.utils';
var MeasureDateRangeSelectionComponent = /** @class */ (function () {
    function MeasureDateRangeSelectionComponent(calendar) {
        this.calendar = calendar;
        this.hideDateRangePopupEvent = new EventEmitter();
        this.changeDateRange = new EventEmitter();
        this.hasChangedDate = false;
        // ES data won't available before 18 Oct, 2018
        this.minDate = NgbDate.from({
            year: 2018,
            month: 10,
            day: 18
        });
    }
    MeasureDateRangeSelectionComponent.prototype.ngOnInit = function () {
        if (this.preSelectedPeriod) {
            this.fromDate = NgbDateUtils.convertNgbDate(this.preSelectedPeriod.formattedStartDate);
            this.toDate = NgbDateUtils.convertNgbDate(this.preSelectedPeriod.formattedEndDate);
        }
        else {
            this.toDate = this.calendar.getToday();
            this.fromDate = this.calendar.getPrev(this.toDate, 'd', MeasureReportTimeline.A_MONTH);
        }
    };
    MeasureDateRangeSelectionComponent.prototype.ngAfterViewInit = function () {
        var _this = this;
        if (this.fromDate) {
            setTimeout(function () {
                _this.dateRangePicker.navigateTo(_this.fromDate);
            }, 100);
        }
    };
    Object.defineProperty(MeasureDateRangeSelectionComponent.prototype, "defaultFromDate", {
        get: function () {
            return this.fromDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureDateRangeSelectionComponent.prototype, "defaultToDate", {
        get: function () {
            return this.toDate;
        },
        enumerable: true,
        configurable: true
    });
    Object.defineProperty(MeasureDateRangeSelectionComponent.prototype, "maxDate", {
        get: function () {
            return this.calendar.getToday();
        },
        enumerable: true,
        configurable: true
    });
    MeasureDateRangeSelectionComponent.prototype.onSelectDateRange = function (evt) {
        this.hasChangedDate = !NgbDateUtils.equals(this.fromDate, evt.fromDate)
            || !NgbDateUtils.equals(this.toDate, evt.toDate);
        this.fromDate = evt.fromDate;
        this.toDate = evt.toDate;
    };
    MeasureDateRangeSelectionComponent.prototype.resetDateRangeSelection = function () {
        this.dateRangePicker.resetDateRange();
        var today = this.calendar.getToday();
        this.onSelectDateRange({
            fromDate: this.calendar.getPrev(today, 'd', MeasureReportTimeline.A_MONTH),
            toDate: today
        });
    };
    MeasureDateRangeSelectionComponent.prototype.applyDateRangeSelection = function () {
        this.changeDateRange.emit({
            fromDate: this.fromDate,
            toDate: this.toDate
        });
        this.hasChangedDate = false;
    };
    MeasureDateRangeSelectionComponent.prototype.onClickedOutside = function (evt) {
        if (!evt.target.classList.contains('date-range-selection') && !evt.target.classList.contains('custom-day')) {
            if (this.fromDate && this.toDate && this.hasChangedDate) {
                this.applyDateRangeSelection();
            }
            this.hideDateRangePopupEvent.emit(evt);
        }
    };
    return MeasureDateRangeSelectionComponent;
}());
export { MeasureDateRangeSelectionComponent };



// WEBPACK FOOTER //
// ./src/app/main/measure/measure-date-range-selection/measure-date-range-selection.component.ts.pre-build-optimizer.js